export const isAndroid = (): boolean => /android/i.test(navigator.userAgent)

export const isIOS = (): boolean => /iphone|ipad|ipod/i.test(navigator.userAgent)

export const isTwitterApp = (): boolean => /Twitter/i.test(navigator.userAgent)

export const isMobile = (): boolean => isAndroid() || isIOS()

export const getDeeplinkPrefix = (env: string): string =>
  ({
    development: "chatbcc-debug://",
    staging: "chatbcc-internal://",
    production: "chatbcc://",
  })[env] || "chatbcc://"

export const getRoomDeeplinkUrl = (env: string, roomId: string): string =>
  `${getDeeplinkPrefix(env)}r/${roomId}`

export const getDeeplinkUrl = (env: string, path: string): string =>
  `${getDeeplinkPrefix(env)}${path}`

const US_AND_CA_TIMEZONES = new Set([
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Anchorage",
  "America/Juneau",
  "America/Sitka",
  "America/Yakutat",
  "America/Nome",
  "America/Adak",
  "America/Metlakatla",
  "America/Phoenix",
  "America/Boise",
  "America/Indiana/Indianapolis",
  "America/Indiana/Knox",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Tell_City",
  "America/Indiana/Vevay",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Detroit",
  "America/Menominee",
  "America/North_Dakota/Beulah",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "Pacific/Honolulu",
  "America/St_Johns",
  "America/Halifax",
  "America/Glace_Bay",
  "America/Moncton",
  "America/Goose_Bay",
  "America/Toronto",
  "America/Nipigon",
  "America/Thunder_Bay",
  "America/Iqaluit",
  "America/Pangnirtung",
  "America/Atikokan",
  "America/Winnipeg",
  "America/Rainy_River",
  "America/Resolute",
  "America/Rankin_Inlet",
  "America/Regina",
  "America/Swift_Current",
  "America/Edmonton",
  "America/Cambridge_Bay",
  "America/Yellowknife",
  "America/Inuvik",
  "America/Dawson_Creek",
  "America/Fort_Nelson",
  "America/Creston",
  "America/Vancouver",
  "America/Whitehorse",
  "America/Dawson",
  "America/Blanc-Sablon",
])

export const isUsOrCaTimezone = (): boolean => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return US_AND_CA_TIMEZONES.has(timezone)
  } catch {
    return false
  }
}
